export default "__VITE_ASSET__$R76rMkT__"